import { render } from "./DocumentSendEmail.vue?vue&type=template&id=201f175f&scoped=true"
import script from "./DocumentSendEmail.vue?vue&type=script&lang=js"
export * from "./DocumentSendEmail.vue?vue&type=script&lang=js"

import "./DocumentSendEmail.vue?vue&type=style&index=0&id=201f175f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201f175f"]])

export default __exports__